import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"info\"><path fill=\"#3483B2\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m1 11c0 .5-.4 1-1 1a1 1 0 0 1-1-1V7c0-.5.4-1 1-1 .3 0 .5.1.7.3s.3.5.3.7zM7 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol